export default __webpack_public_path__ + "static/media/antethesizer.372456dd.png";